import { Locale, type LocalizedString } from "./Locale.js";

export const localeShortHandMap = {
	[Locale.cs]: "cz",
	[Locale.en]: "en",
} satisfies LocalizedString;
